import React from 'react';

import Link from 'next/link';

export default function AITravelPlannerPromo() {
  return (
    <div className="mt-8 mb-12 bg-gradient-to-r from-blue-500 to-purple-600 text-white p-6 rounded-lg shadow-lg">
      <h3 className="text-2xl font-bold mb-2">Plan Your Perfect Trip with AI</h3>
      <p className="mb-4">Get personalized travel recommendations and answers to your questions with our Next-Gen Travel Search.</p>
      <Link href="/next-gen-travel-search" className="inline-block bg-white text-blue-600 font-semibold py-2 px-4 rounded hover:bg-blue-100 transition duration-300">
        Try AI Travel Planner
      </Link>
    </div>
  );
}